import { VIOLATION_TYPE_TO_USER_STRING_MAP } from '../constants';
import { ViolationType } from '../types';

const getViolationDisplayText = (violationType: string | undefined): string => {
  if (violationType && violationType in VIOLATION_TYPE_TO_USER_STRING_MAP) {
    return VIOLATION_TYPE_TO_USER_STRING_MAP[violationType as ViolationType];
  }

  if (!violationType) {
    return 'Unknown';
  }

  return violationType;
};

export const TypeCellRenderer = ({ value }: { value: string | undefined }) => {
  const displayText = getViolationDisplayText(value);

  return (
    <div className="flex items-center px-2">
      <div data-testid="violation-type">{displayText}</div>
    </div>
  );
};
